import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-shell" }
const _hoisted_2 = { class: "admin-nav" }
const _hoisted_3 = { class: "admin-nav-left" }
const _hoisted_4 = { class: "admin-nav-title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "admin-nav-right" }
const _hoisted_8 = { class: "admin-nav-user" }
const _hoisted_9 = {
  key: 0,
  class: "admin-body"
}
const _hoisted_10 = { class: "sidebar-mobile-header" }
const _hoisted_11 = { class: "sidebar-nav" }
const _hoisted_12 = { class: "admin-main" }
const _hoisted_13 = { class: "mobile-topbar" }
const _hoisted_14 = { class: "mobile-section-label" }
const _hoisted_15 = { class: "tab-content" }
const _hoisted_16 = {
  key: 1,
  class: "admin-loading"
}
const _hoisted_17 = { class: "modal-box" }
const _hoisted_18 = { class: "modal-body-text" }
const _hoisted_19 = { class: "modal-actions" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "admin-nav-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/administrador/dashboard')))
          }, "← Obras"),
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "admin-nav-sep" }, "|", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.detail?.siteName || '...'), 1),
          ($setup.detail)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn-toggle-status", $setup.detail.disabled ? 'btn-reativar' : 'btn-suspender']),
                type: "button",
                disabled: $setup.toggling,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleStatus && $setup.toggleStatus(...args)))
              }, _toDisplayString($setup.toggling ? 'Aguarde...' : $setup.detail.disabled ? 'Reativar obra' : 'Suspender obra'), 11, _hoisted_5))
            : _createCommentVNode("", true),
          ($setup.detail && $setup.detail.disabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn-toggle-status btn-deletar",
                type: "button",
                disabled: $setup.deleting,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.softDelete && $setup.softDelete(...args)))
              }, _toDisplayString($setup.deleting ? 'Deletando...' : 'Deletar obra'), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString($setup.masterSessionStore.state.admin?.name), 1),
          _createElementVNode("button", {
            class: "admin-nav-logout",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
          }, "Sair")
        ])
      ]),
      ($setup.detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            ($setup.sidebarOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "sidebar-backdrop",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.sidebarOpen = false))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("aside", {
              class: _normalizeClass(["admin-sidebar", { 'admin-sidebar--open': $setup.sidebarOpen }])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "sidebar-close-btn",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.sidebarOpen = false))
                }, "✕")
              ]),
              _createElementVNode("nav", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navItems, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.path,
                    to: item.path,
                    class: "sidebar-link",
                    "active-class": "sidebar-link--active",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.sidebarOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ], 2),
            _createElementVNode("main", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "hamburger-btn",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.sidebarOpen = true))
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("span", null, null, -1),
                  _createElementVNode("span", null, null, -1),
                  _createElementVNode("span", null, null, -1)
                ]))]),
                _createElementVNode("span", _hoisted_14, _toDisplayString($setup.currentNavLabel), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_view)
              ])
            ])
          ]))
        : ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Carregando..."))
          : _createCommentVNode("", true)
    ]),
    ($setup.showDeleteConfirm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => ($setup.showDeleteConfirm = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "modal-title modal-title-danger" }, "Deletar obra", -1)),
            _createElementVNode("p", _hoisted_18, [
              _cache[13] || (_cache[13] = _createTextVNode(" Tem certeza que deseja deletar ", -1)),
              _createElementVNode("strong", null, _toDisplayString($setup.detail?.siteName), 1),
              _cache[14] || (_cache[14] = _createTextVNode("?", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
              _cache[16] || (_cache[16] = _createTextVNode(" A obra sumirá do painel principal e seu username ficará disponível.", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
              _cache[18] || (_cache[18] = _createTextVNode(" Esta ação pode ser revertida pela aba ", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("em", null, "Deletadas", -1)),
              _cache[20] || (_cache[20] = _createTextVNode(". ", -1))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn-admin-ghost",
                type: "button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showDeleteConfirm = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn-admin-danger",
                type: "button",
                disabled: $setup.deleting,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.confirmDelete && $setup.confirmDelete(...args)))
              }, _toDisplayString($setup.deleting ? 'Deletando...' : 'Confirmar deletar'), 9, _hoisted_20)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}